var map = {
	"./DR-CHAITHRA-SHENOY-MD.jpg": 272,
	"./Dr-Abhishek-new.jpg": 273,
	"./Dr-Chandrashekar-BS.jpg": 274,
	"./Dr-Kusuma-M-R.jpg": 275,
	"./Dr-Madhura-C.jpg": 276,
	"./Dr-Rashmi-Agarwal-img.jpg": 277,
	"./Dr-Shruthi-C.jpg": 278,
	"./Dr-Vani-Vasanth-MD-FRGUHS-Aesthetic-Dermatology.jpg": 279,
	"./Dr-preethi-nayak.jpg": 280,
	"./Dr.-Harsha-MD-FRGUHS-Dermatosurgery.jpg": 281,
	"./Dr.Prarthana-B-Desai-MD-FRGUHS-Aesthetic-Dermatology.jpg": 282,
	"./Shruti-Bidarkar-500x500.jpg": 283,
	"./anu-george.jpg": 284,
	"./apoorva-h.jpg": 285,
	"./atul1.png": 286,
	"./atul2.png": 287,
	"./doctors-1.jpg": 288,
	"./doctors-2.jpg": 289,
	"./doctors-3.jpg": 290,
	"./doctors-4.jpg": 291,
	"./dr-candice.jpg": 292,
	"./dr-chandrasekar.jpg": 293,
	"./dr-darshana.jpg": 294,
	"./dr-madura-c.jpg": 295,
	"./dr-maria-rupani.jpg": 296,
	"./dr-megha-cutis.jpg": 297,
	"./dr-megha-r.jpg": 298,
	"./dr-monisha.jpg": 299,
	"./dr-nayana.jpg": 300,
	"./dr-nisha.jpg": 301,
	"./dr-poojitha-cutis.jpg": 302,
	"./dr-priya-d.jpg": 303,
	"./dr-priya-prem.jpg": 304,
	"./dr-ruhi-1.jpg": 305,
	"./dr-ruhi.jpg": 306,
	"./dr-warood.jpg": 307,
	"./dr_supreeth.jpg": 308,
	"./oliver-lobo.jpg": 309,
	"./priya-prem-new.jpg": 310,
	"./ritu_agarwal.jpg": 91,
	"./shruthi.jpg": 311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;